import type { Answer } from '../../../types/answer'
import type { Form } from '../../../types/form'

const formatPreviewFormResponse = (
  form: Form,
  answers: Answer[],
  teamDetails: ?TeamDetails
) => {
  return {
    form,
    name: '',
    answers,
    created_at: '',
    id: 'id',
    is_archived: false,
    is_submitted: false,
    is_scheduled: false,
    internal_user: null,
    team_details: teamDetails || undefined,
    uid: 'uid',
  }
}

export default formatPreviewFormResponse
